import { Box } from "@mui/material";
import { H3, Small } from "../components/Typography";
import { FC } from "react";

// component props interface
interface DashBoardCardProps {
  image?: string;
  heading?: string;
  subheading?: string;
  bgColor?: string;
  onPress?: any;
  index?: any;
}

const DashBoardCard: FC<DashBoardCardProps> = ({
  image,
  heading,
  subheading,
  bgColor,
  onPress,
  index,
}) => {
  return (
    <Box
      sx={{
        marginLeft: {
          md: index === 0 ? 0 : 2,
          xs: 0,
        },
        display: "flex",
        justifyContent: "space-between",
        width: {
          xs: "100%",
          md: "30%",
        },
        pt: 2,
        background: bgColor,
        borderRadius: 3,
        pl: 2,
        mt: {
          xs: 2,
          md: 0,
        },
        cursor: "pointer",
        overflow: "hidden",
      }}
      onClick={onPress}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        <Box
          sx={{
            width: {
              md: "70%",
              xs: "100%",
            },
            pb: 2,
          }}
        >
          <H3
            fontWeight={500}
            fontSize={16}
            color="#F6F6F6"
            sx={{
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {heading}
          </H3>
          <Small
            sx={{
              fontWeight: "400",
              fontFamily: "'Poppins', sans-serif",
            }}
            color="#F6F6F6"
          >
            {subheading}
          </Small>
        </Box>

        <Box
          sx={{
            width: {
              md: "75%",
              xs: "100%",
            },
            alignSelf: "flex-end",
            display: "flex",
            bottom: 0,
            justifyContent: {
              xs: "flex-end",
            },
          }}
        >
          <Box
            component="img"
            sx={{
              height: {
                xs: "100%",
                sm: "60%",
                md: "100%",
              },
              width: {
                xs: "100%",
                sm: "60%",
                md: "100%",
              },
              alignSelf: "flex-end",
              //borderBottomRightRadius: 15,
            }}
            src={image}
            alt="saas"
          />
        </Box>
      </div>
    </Box>
  );
};

export default DashBoardCard;
